import MobileDetect from 'mobile-detect'

export default ({ req, store }, inject) => {
  const device = function () {
    const userAgent = req?.headers?.['user-agent'];

    if (!!userAgent) {
      const md = new MobileDetect(userAgent);
      const isMobile = md.phone() !== null || md.mobile() === 'UnknownMobile';
      const isTablet = md.tablet() !== null || md.mobile() === 'UnknownTablet';
      const isDesktop = !isMobile && !isTablet;

      store.commit("device/setDevice", {
        isMobile,
        isTablet,
        isDesktop
      });
    }
  };
  inject('device', device);
};
